/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.checkAccountStatus'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  activated: /*#__PURE__*/ l.boolean(),
  validDid: /*#__PURE__*/ l.boolean(),
  repoCommit: /*#__PURE__*/ l.string({ format: 'cid' }),
  repoRev: /*#__PURE__*/ l.string(),
  repoBlocks: /*#__PURE__*/ l.integer(),
  indexedRecords: /*#__PURE__*/ l.integer(),
  privateStateValues: /*#__PURE__*/ l.integer(),
  expectedBlobs: /*#__PURE__*/ l.integer(),
  importedBlobs: /*#__PURE__*/ l.integer(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns the status of an account, especially as pertaining to import or recovery. Can be called many times over the course of an account migration. Requires auth and can only be called pertaining to oneself. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid
